module.exports = __webpack_public_path__ + "static/media/icn-download.c8048f97.svg";